import { Button } from '@/components/atoms/ui/button';
import { User } from '@/types/models';

interface FollowButtonComponentProps {
  currentUser: User | null;
  userId: string;
  username: string;
  isFollowingUser: boolean;
  loading: boolean;
  initialLoading: boolean;
  onFollow: () => void;
}

export const FollowButtonComponent: React.FC<FollowButtonComponentProps> = ({
  currentUser,
  userId,
  username: _username,
  isFollowingUser,
  loading,
  initialLoading,
  onFollow,
}) => {
  // Don't show button if viewing own profile or not signed in
  if (!currentUser || currentUser.uid === userId || initialLoading) {
    return null;
  }

  return (
    <Button
      onClick={onFollow}
      disabled={loading}
      variant={isFollowingUser ? 'secondary' : 'default'}
      className="follow-button-component flex items-center gap-2"
    >
      {loading ? (
        <>
          <span className="animate-spin inline-block w-4 h-4 border-2 border-current border-t-transparent rounded-full mr-1" />
          {isFollowingUser ? 'Unfollowing...' : 'Following...'}
        </>
      ) : isFollowingUser ? (
        'Following'
      ) : (
        'Follow'
      )}
    </Button>
  );
};

